export default __webpack_public_path__ + "static/media/20.b0f7c1f7.mp3";